import {Button, Form, Input, Modal, Switch, Tabs} from 'antd';
import React, { useEffect, useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import bannerService from '../../services/banner-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import UploadImage from '../../components/upload/image';
import EditableTagGroup from '../../components/input/editable-tag-group';
import { fileTYPE_IMG, groupType, VISIBILITY_DEFAULT } from '../../constants/app-constants';
import fileUtils from '../../utils/file-utils';
import VisibilityFormItem from '../../components/input/visibility-form-item';
import StatusSwitchFormItem from '../../components/input/status-switch-form-item';
import { FORM_LANG, formText, langOfTab } from '../../constants/form-i18n';

const { TabPane } = Tabs;

const defaultValue = {
    bannerImage: null,
    isOpenNewTab: false,
    keywordList: [],
};

const AddEditBannerDialog = ({ isShow, onCancel, onSaveComplete, editData }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [bannerImage, setBannerImage] = useState(defaultValue.bannerImage);
    const [keywordList, setKeywordList] = useState(defaultValue.keywordList);
    /**
     * NMU-444: switching to the English tab puts the whole dialog into English,
     * not just the one field being translated — labels, helper text, the modal
     * title and the footer buttons all follow the active tab.
     */
    const [lang, setLang] = useState(FORM_LANG.TH);
    const t = formText(lang);

    useEffect(() => {
        if (!isShow) {
            setBannerImage(defaultValue.bannerImage);
            setKeywordList(defaultValue.keywordList);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                title: editData.title,
                titleEN: editData.titleEN,
                url: editData.url,
                status: editData.status,
                totalView: editData.totalView,
                enableNewTab: editData.enableNewTab,
                visibility: editData.visibility ? editData.visibility : VISIBILITY_DEFAULT
            });

            setBannerImage(editData.attachImage);
            setKeywordList(editData.keywordList ? editData.keywordList : defaultValue.keywordList);
         
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            const values = await form.validateFields();
            try {

                dispatch(appLoaderAction.enable());
                
                if (!editData) {
                    let bean = {
                        title: values.title,
                        titleEN: values.titleEN,
                        keywordList: keywordList,
                        url: values.url,
                        attachImage: bannerImage,
                        enableNewTab: values.enableNewTab,
                        status: values.status,
                        visibility: values.visibility,
                        totalView: 0
                    };

                    await bannerService.add({bean: bean});
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    bean.title = values.title;
                    bean.titleEN = values.titleEN;
                    bean.keywordList = keywordList;
                    bean.url = values.url;
                    bean.attachImage = bannerImage;
                    bean.enableNewTab = values.enableNewTab;
                    bean.status = values.status;
                    bean.visibility = values.visibility;
                    bean.totalView = editData.totalView;
                    await bannerService.edit({bean: bean});
                }

                dispatch(appLoaderAction.disale());
                notifyUtitls.success(t('successTitle'), t('saveSuccess'));
                onSaveComplete();
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning(t('warningTitle'), t('incompleteForm'));
        }
    };

    const onUploadTemp = ({ file }) => {
        if (file.status === 'done') {
            const { bean } = file.response;
            setBannerImage(bean);
        }
	};

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={t(editData ? 'editBanner' : 'addBanner')}
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />{t('save')}
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            {t('cancel')}
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_banner"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true, visibility: VISIBILITY_DEFAULT}}
                        validateMessages={{
                            required: t('required'),
                        }}>

                        {/* NMU-403: banner name is bilingual — Thai + English tab.
                            NMU-506: neither is required. A banner is the image; the
                            name is an internal label for the admin list, and the
                            public Hero simply renders no heading when it is blank. */}
                        <Tabs defaultActiveKey="1" onChange={(key) => setLang(langOfTab(key))}>
                            <TabPane tab={t('tabThai')} key="1" forceRender>
                                <Form.Item label={t('bannerName')} name="title">
                                    <Input />
                                </Form.Item>
                            </TabPane>
                            <TabPane tab={t('tabEnglish')} key="2" forceRender>
                                <Form.Item label={t('bannerNameEN')} name="titleEN">
                                    <Input />
                                </Form.Item>
                            </TabPane>
                        </Tabs>

                        <Form.Item
                            label={t('bannerImage')}
                            valuePropName="fileList"
                            name="imageHeader"
                            rules={[
                                {
                                    required: bannerImage ? false : true,
                                    // NMU-532: a picture is uploaded, not typed.
                                    message: 'กรุณาอัปโหลดรูปภาพ',
                                },
                            ]}>
                            <UploadImage  
                                listType="picture-card"
                                accept={fileTYPE_IMG}
                                showUploadList={false}
                                onChange={onUploadTemp}
                                className={bannerImage ? 'view-upload' : null}>
                                  {bannerImage ? (
                                        <img
                                            src={
                                                bannerImage.tempFilename
                                                    ? fileUtils.getTempFileRenderUrl(
                                                            bannerImage.tempFilename,
                                                            bannerImage.type
                                                    )
                                                    : fileUtils.getFileRenderUrl(
                                                            groupType.BANNER,
                                                            editData ? editData.bannerId : null,
                                                            bannerImage.originalFilename
                                                    )
                                            }
                                            alt="avatar"
                                            style={{ width: '100%' }}
                                        />
                                    ) : t('uploadFile')}
                            </UploadImage>
                            <label className="text-danger">{t('bannerImageHint')}</label>
                        </Form.Item>

                        <Form.Item label={t('link')} name="url">
                            <Input />
                        </Form.Item>

                        <Form.Item label={t('keywords')} >
                            <EditableTagGroup onChange={setKeywordList} tags={keywordList} lang={lang} />
                        </Form.Item>

                        <Form.Item label={t('openInNewTab')} name="enableNewTab" valuePropName="checked">
                            <Switch />
                        </Form.Item>

                        {/* NMU-527: the toggle says which it is, in the same
                            green/grey the banner table uses for this field. */}
                        <StatusSwitchFormItem label={t('status')} />

                        <VisibilityFormItem lang={lang} />

                    </Form>
                </Modal>
            </div>
        </div>
    )
};

export default AddEditBannerDialog;